import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

import { PortalRoutesWrapper } from "@/app/components/auth";
import { ShopContextProvider } from "@/features/products/context";
import {
  ShopOverviewScreen,
  ShopSummaryScreen,
} from "@/features/products/screens";
import { SHOP_ROUTES } from "./constants";

export const getShopRoute = (): RouteObject => ({
  path: SHOP_ROUTES.BASE,
  element: (
    <ShopContextProvider>
      <PortalRoutesWrapper />
    </ShopContextProvider>
  ),

  children: [
    {
      index: true,
      element: <ShopOverviewScreen />,
    },
    {
      path: SHOP_ROUTES.SUMMARY,
      element: <ShopSummaryScreen />,
    },

    { path: "*", element: <Navigate replace to={SHOP_ROUTES.BASE} /> },
  ],
});
